import React from 'react';
import {Modal} from 'react-bootstrap'

const ErrorMessage = ({message, show, closePop, lang}) => {

    return (

        <Modal show={show} onHide={() => closePop('error')} centered className={`my-modal ${lang}`}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <h5 className="error-message text-center">{message}</h5>
            </Modal.Body>

        </Modal>

    );
};

export default ErrorMessage
